export const WELCOME_DIALOG_DISMISSED_STORAGE_KEY = 'site-summary-welcome-dialog-dismissed';
export const GNR_OVERVIEW_WELCOME_DIALOG_DISMISSED_STORAGE_KEY = 'gnr-overview-welcome-dialog-dismissed';
export const GNR_OVERVIEW_INFO_BANNER_DISMISSED_STORAGE_KEY = 'gnr-overview-info-banner-dismissed';
